import { ReactElement } from 'react';
import { BaseIcon, BaseIconProps } from '../BaseIcon';

export const CheckIcon = ({ ...props }: Omit<BaseIconProps, 'children'>): ReactElement => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" hasLegacyStrokeStyles={true} {...props}>
    <path d="M20 6L9 18L4 13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </BaseIcon>
);

CheckIcon.displayName = 'CheckIcon';
